import Cookies from 'js-cookie'

function cookiesSet(key, value){
  var url = window.location.href
  var pathPrefix = process.env.PREFIXES
  if (url.indexOf('shopadmin') !== -1) {
    var path = pathPrefix + '/shopadmin'
  } else {
    var path = pathPrefix
  }
  if (value) {
    // Cookies.set(key, value, { path: path, secure: true, sameSite: 'Lax' })
    localStorage.setItem(key, value)
  } else {
    // Cookies.remove(key, { path: path})
    localStorage.removeItem(key)
  }

  //如果是登录
  if (key == 'jwt_token') {
    var loginkey = 'is_login' + path
    if (value) {
      // Cookies.set(loginkey, 1)
      localStorage.setItem(loginkey, 1)
    } else {
      // Cookies.remove(loginkey)
      localStorage.removeItem(loginkey)
    }
  }
}

function cookiesGet(key){
  var url = window.location.href
  var pathPrefix = process.env.PREFIXES
  if (url.indexOf('shopadmin') !== -1) {
    var path = pathPrefix + '/shopadmin'
  } else {
    var path = pathPrefix
  }

  if (key == 'jwt_token') {
    var loginkey = 'is_login' + path
    // if (!Cookies.get(loginkey)) {
    if (!localStorage.getItem(loginkey)) {
      return ;
    }
  }

  return localStorage.getItem(key)
  // return Cookies.get(key, { path: path})
}

const user = {
  state: {
    token: cookiesGet('jwt_token'),
    exp: cookiesGet('token_exp'),
    name: cookiesGet('user_name'),
    is_authorizer: cookiesGet('is_authorizer'),
    license_authorize: cookiesGet('license_authorize'),
    route_app: cookiesGet('route_app'),
    wxapp_id: cookiesGet('wxapp_id'),
    template_name: cookiesGet('template_name'),
    login_type: cookiesGet('login_type'),
    nick_name: cookiesGet('nick_name'),
    avatar: cookiesGet('avatar'),
  },

  mutations: {
    setToken: (state, token) => {
      state.token = token
      cookiesSet('jwt_token', token)
    },
    setTokenExp: (state, exp) => {
      state.exp = exp
      cookiesSet('token_exp', exp)
    },
    setUserName: (state, name) => {
      state.name = name
      cookiesSet('user_name', name)
    },
    setNickName: (state, nickName) => {
      state.nick_name = nickName
      cookiesSet('nick_name', nickName)
    },
    setAvatar: (state, avatar) => {
      state.avatar = avatar
      cookiesSet('avatar', avatar)
    },
    setAuthorizer: (state, isAuthorizer) => {
      state.is_authorizerr = isAuthorizer
      cookiesSet('is_authorizer', isAuthorizer)
    },
    setLicenseAuthorize: (state, isLicenseValid) => {
      state.license_authorize = isLicenseValid
      cookiesSet('license_authorize', isLicenseValid)
    },
    setWxappId: (state, wxappId) => {
      state.wxapp_id = wxappId
      if (wxappId) {
        cookiesSet('wxapp_id', wxappId)
      } else {
        cookiesSet('wxapp_id')
      }
    },
    setLoginType: (state, loginType) => {
      if (loginType) {
        cookiesSet('login_type', loginType)
      } else {
        cookiesSet('login_type')
      }
      state.login_type = loginType
      state.token = cookiesGet('jwt_token')
      state.exp = cookiesGet('token_exp')
      state.name = cookiesGet('name')
      state.nick_name = cookiesGet('nick_name')
      state.avatar = cookiesGet('avatar')
      state.is_authorizer = cookiesGet('is_authorizer')
      state.license_authorize = cookiesGet('license_authorize')
    },
    setCompanyType: (state, companyType) => {
      state.company_type = companyType
      if (companyType) {
        cookiesSet('company_type', companyType)
      } else {
        cookiesSet('company_type')
      }
    },
    setTemplateName: (state, templateName) => {
      state.template_name = templateName
      if (templateName) {
        cookiesSet('template_name', templateName)
      } else {
        cookiesSet('template_name')
      }
    }
  },

  actions: {
    setAuthorizer ({commit}, is_authorizer) {
      commit('setAuthorizer', is_authorizer)
    },
    setLicenseAuthorize ({commit}, license_authorize) {
      commit('setLicenseAuthorize', license_authorize)
    },
    // 保存token
    setToken ({commit}, token) {
      commit('setToken', token)
      // 解析token中的user信息，并且保存
      let tokenArray = token.split('.')
      let user = atob(tokenArray[1])
      user = JSON.parse(user)
      commit('setTokenExp', user.exp)
      commit('setUserName', user.mobile)
      commit('setAuthorizer', user.is_authorizer)
      commit('setLicenseAuthorize', user.license_authorize)
    },
    // 删除token
    unsetToken ({commit}, token) {
      commit('setToken', '')
      commit('setTokenExp', '')
      commit('setUserName', '')
      commit('setAuthorizer', '')
      commit('setLicenseAuthorize', '')
    },
    setUser ({commit}, userInfo) {
      commit('setNickName', userInfo.username)
      commit('setAvatar', userInfo.head_portrait)
    },
    setWxappId ({commit}, wxapp_id) {
      commit('setWxappId', wxapp_id)
    },

    setTemplateName ({commit}, template_name) {
      commit('setTemplateName', template_name)
    },
    setLoginType({commit}, login_type) {
      commit('setLoginType', login_type)
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js